//declare var angular: any;
/**
 * Base dialog
 */
var BaseDialogService = (function () {
    function BaseDialogService($mdDialog, $sce, $rootScope, socket, env, settings) {
        this.$mdDialog = $mdDialog;
        this.$sce = $sce;
        this.$rootScope = $rootScope;
        this.socket = socket;
        this.env = env;
        this.settings = settings;
    }
    BaseDialogService.prototype.show = function ($event, template, items) {
        this.data = items.data;
        var parentEl = angular.element(document.body);
        return this.$mdDialog.show({
            bindToController: true,
            locals: items,
            parent: angular.element(document.body),
            targetEvent: $event,
            templateUrl: template,
            // tslint:disable-next-line: object-literal-sort-keys
            controller: ['$mdDialog', function ($mdDialog) {
                    this.cancel = function () { return $mdDialog.cancel; };
                    this.hide = function () { return $mdDialog.hide; };
                }],
            controllerAs: 'vm',
            clickOutsideToClose: false,
            escapeToClose: true,
            closeTo: parentEl
        });
    };
    BaseDialogService.prototype.cancel = function () {
        this.$mdDialog.cancel();
    };
    BaseDialogService.prototype.hide = function () {
        this.$mdDialog.hide();
    };
    BaseDialogService.prototype.getData = function () {
        return this.data;
    };
    BaseDialogService.$inject = ['$mdDialog', '$sce', '$rootScope', 'socket', 'env', 'settings'];
    return BaseDialogService;
}());
angular
    .module('application')
    .service('baseDialog', BaseDialogService);

//# sourceMappingURL=baseDialog.js.map
